import { InputGroup, TextLink } from "@kensho/neo";
import { use } from "react";

import { BasePage } from "../components/base-page";
import { CopyableValue } from "../components/copyable-value";
import { DictionaryPreference } from "../core/account/dictionary-preference";
import { UserContext } from "../providers/user-context";

export function AccountPage() {
  const { user } = use(UserContext);

  if (!user) throw new Error("Unauthenticated");

  return (
    <BasePage>
      <main className="mx-auto my-0 flex w-full max-w-[900px] flex-col gap-4 p-7 pb-0">
        <h1 className="text-2xl text-gray-800">Account</h1>

        {user.email && (
          <div className="max-w-80">
            <InputGroup value={user.email} label="Email Address" readOnly />
          </div>
        )}

        <CopyableValue
          value={user.refreshToken}
          label="Refresh Token"
          description="Used to generate new temporary Access Tokens"
        />
        {user.token && (
          <CopyableValue
            value={user.token}
            label="Access Token"
            description="Used to programmatically access the API"
          />
        )}

        <div>
          See the{" "}
          <TextLink href="https://docs.kensho.com/authentication/personal-token">
            Personal Token Authentication Guide
          </TextLink>{" "}
          for information on token usage.
        </div>

        <DictionaryPreference />
      </main>
    </BasePage>
  );
}
